import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type {
  UiFlowConnectorOrientation,
  UiFlowConnectorStyle,
} from '../../shared/flow/flow.types';

@Component({
  selector: 'ui-flow-connector',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="ui-flow-connector"
      [class]="connectorClass()"
      [style.width]="orientation() === 'horizontal' ? length() : null"
      [style.height]="orientation() === 'vertical' ? length() : null"
      aria-hidden="true"
    >
      <span class="ui-flow-connector__line"></span>
      @if (arrow()) {
        <span class="ui-flow-connector__arrow"></span>
      }
    </div>
  `,
  styles: `
    :host { display: inline-flex; }
    .ui-flow-connector {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #94a3b8;
    }
    .ui-flow-connector--horizontal {
      min-width: 24px;
      height: 12px;
      flex-direction: row;
    }
    .ui-flow-connector--vertical {
      width: 12px;
      min-height: 24px;
      flex-direction: column;
    }
    .ui-flow-connector__line {
      flex: 1 1 auto;
      background: currentColor;
    }
    .ui-flow-connector--horizontal .ui-flow-connector__line { height: 1px; width: 100%; }
    .ui-flow-connector--vertical .ui-flow-connector__line { width: 1px; height: 100%; }
    .ui-flow-connector--dashed .ui-flow-connector__line {
      background: repeating-linear-gradient(
        to right,
        currentColor 0 4px,
        transparent 4px 8px
      );
    }
    .ui-flow-connector--vertical.ui-flow-connector--dashed .ui-flow-connector__line {
      background: repeating-linear-gradient(
        to bottom,
        currentColor 0 4px,
        transparent 4px 8px
      );
    }
    .ui-flow-connector__arrow {
      width: 0;
      height: 0;
      border-style: solid;
      flex: 0 0 auto;
    }
    .ui-flow-connector--horizontal .ui-flow-connector__arrow {
      border-width: 3px 0 3px 5px;
      border-color: transparent transparent transparent currentColor;
    }
    .ui-flow-connector--vertical .ui-flow-connector__arrow {
      border-width: 5px 3px 0 3px;
      border-color: currentColor transparent transparent transparent;
    }
  `,
})
export class UiFlowConnectorComponent {
  readonly orientation = input<UiFlowConnectorOrientation>('horizontal');
  readonly lineStyle = input<UiFlowConnectorStyle>('solid');
  readonly arrow = input(true);
  readonly length = input('48px');

  protected readonly connectorClass = computed(
    () =>
      `ui-flow-connector--${this.orientation()} ui-flow-connector--${this.lineStyle()}`,
  );
}
